export default {
    data() {
        return {
            rules: {
                required: v => (!!v && v.length > 0) || 'Required',
                positiveNumberRequired: v => (v != null && parseFloat(v) > 0) || 'Valid Number Required',
                numberRequired: v => (v != null && parseFloat(v) >= 0) || 'Valid Number Required',
                boolRequired: v => v != null || 'Required',
                objectRequired: v => !!v || 'Required',
                sortCodeRequired: v => (/^[\d]{2}-[\d]{2}-[\d]{2}$/.test(v)) || 'Valid Sort Code Required',
                bankAccountNumberRequired: v => (/^[\d]{8}$/.test(v)) || 'Valid Bank Account Number Required',
            },
        }
    },
};